import 'aos/dist/aos.css';
import AOS from 'aos';

export default {
    init() {
        AOS.init();
    }
};
